export default "__VITE_ASSET__BSXuDXRi__ 1200w";